import React from "react";

const Favourite = () => {
  return (
    <div>
      <h1>Favourite Page</h1>
    </div>
  );
};

export default Favourite;
